import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_login_code = (username) => {
  // Send username as a query parameter in the URL, e.g. ?UserName=admin
  return api.post(
    `${ApiEndpointConstants.GETLOGINCODE}`,
    {},
    {
      params: {
        UserName: username,
      },
    }
  );
};
